import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { GroupOwner } from "../../../types/groupOwner.types";
import { request } from "../api";

const initialRoute = "redirection";
const { get } = request;

export const redirectUser = async (
	_id: string,
	token: string
): Promise<{ token: string; role: "EMPLOYEE" | "DEPENDENT" }> => {
	try {
		const endpoint = initialRoute;
		const params = {
			_id
		};
		// console.log("Bearer_header", token);
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			params
		);
		// console.log("response", response);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				const { token, role } = result;
				return { token, role };
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		alert(err);
		throw err;
	}
};

export const redirection = {
	redirectUser
};
